export function watchGlobalVariable(variable, clear = false) {
  return new Promise((resolve) => {
    let initialValue = window[variable]

    if (initialValue !== undefined) {
      resolve(initialValue)
      if (clear) {
        delete window[variable]
      }
      return
    }

    let internalValue
    const descriptor = Object.getOwnPropertyDescriptor(window, variable)

    Object.defineProperty(window, variable, {
      configurable: true,
      enumerable: true,
      get() {
        return internalValue
      },
      set(value) {
        internalValue = value
        resolve(value)

        if (clear) {
          if (descriptor) {
            Object.defineProperty(window, variable, descriptor)
          } else {
            delete window[variable]
          }
        }
      },
    })
  })
}
